import { useRef } from 'react';
import Button from '../../../../shared/components/Button/Button';

export default function ExpenseFilePicker({ label, ariaLabel, disabled, onFile }) {
  const input = useRef(null);
  return <span className="expense-file">
    <input ref={input} type="file" hidden accept="application/pdf,image/jpeg,image/png" disabled={disabled} aria-label={ariaLabel} onChange={event => { const file = event.target.files?.[0]; event.target.value = ''; if (file) onFile(file); }} />
    <Button size="small" disabled={disabled} onClick={() => input.current?.click()} aria-label={`Choisir un fichier : ${ariaLabel}`}>{label}</Button>
  </span>;
}
